// extracted by mini-css-extract-plugin
module.exports = {"tablet":"680px","laptop":"980px","desktop":"1180px","dl":"faqs_dl__Aa8C6","faq":"faqs_faq__80gdm","button":"faqs_button__87tbT"};